import { Empresa } from './empresa';

export class ItemPedido  {
    public Id: number;    
    public Empresa: Empresa;
    public RedProdutoKey: number;    
    public Preco: number; 
}


// WEBPACK FOOTER //
// ./src/entities/ItemPedido.ts